import {translations} from 'presentation/translations-new';

const {searchProfessional, searchUnit, searchNeighborhood, searchSpecialty} =
	translations['pt-br'].privateFlow.bookingFlow;

const SEARCH_BAR_PLACEHOLDER = {
	withGeo: ['', searchSpecialty, searchUnit, searchProfessional, ''],
	withoutGeo: ['', searchSpecialty, searchNeighborhood, searchUnit, searchProfessional, ''],
};

export {SEARCH_BAR_PLACEHOLDER};
